// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Stack, Typography } from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import Logo from 'ui-component/Logo';
// import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import ClinicSelection from './ClinicSelectSection';
import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';
import useTwilioCall from 'hooks/useTwilioCall';

// assets
import { IconMenu2, IconPhone } from '@tabler/icons';

function formatCallDuration(totalSeconds) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
    const theme = useTheme();

    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);
    const { isActive, status, durationSeconds, patientSnapshot } = useTwilioCall();

    // While a call is active the chrome swaps to a minimal "in-call" presentation
    // so the provider can't navigate to a different patient mid-call. ProfileSection
    // stays so logout / account controls remain reachable.
    if (isActive) {
        const fullName = patientSnapshot ? `${patientSnapshot.firstName ?? ''} ${patientSnapshot.lastName ?? ''}`.trim() : '';
        const callLabel =
            status === 'inCall'
                ? `On call with ${fullName || 'patient'} — ${formatCallDuration(durationSeconds)}`
                : `Calling ${fullName || 'patient'}…`;

        return (
            <>
                <Box
                    sx={{
                        width: 228,
                        display: 'flex',
                        [theme.breakpoints.down('md')]: {
                            width: 'auto'
                        }
                    }}
                >
                    <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                        <Logo />
                    </Box>
                </Box>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ flexGrow: 1, ml: 2, color: theme.palette.primary.main }}>
                    <IconPhone size={20} />
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                        {callLabel}
                    </Typography>
                </Stack>
                <ProfileSection />
            </>
        );
    }

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                    <LogoSection />
                </Box>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                        }
                    }}
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    color="inherit"
                >
                    <IconMenu2 stroke={1.5} size="1.3rem" />
                </Avatar>
            </Box>

            {/* header search */}
            {/* <SearchSection /> */}
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ flexGrow: 1 }} />
            <ClinicSelection />

            {/* notification & profile */}
            <ProfileSection />

            {/* mobile header */}
            <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <MobileSection />
            </Box>
        </>
    );
};

export default Header;
